/**
 * Created by Suhel Shrestha on 3/18/19
 */
import React, { Component, PropTypes } from 'react';
import ReactDropzone from 'react-dropzone';
import request from 'superagent';
import { BASE_URL } from '../../config';
import Modal from '../Modal';
import {token} from '../../libs/localStorage';

export default class ProductRelatedFileAdd extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };
  slug;
  title = 'Add Product Related File';

  constructor(props) {
    super(props);
    this.slug = `/inventory/product/${props.params.id}/files`;
    this.onOpenClick = this.onOpenClick.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  onOpenClick() {
    this.refs.dropzone.open();
  }

  onDrop(files) {
    const url = `${BASE_URL}/api/inventory/product/${this.props.params.id}/related-file/upload`;
    const {notify, router} = this.context;

    const req = request
      .post(url)
      .set('Authorization', `Bearer ${token.getEncoded()}`);

    files.forEach(file => {
      req.attach('photo', file);
    });
    req.end((err, res) => {
      if(!err){
        router.replace(this.slug);
        notify.success(JSON.parse(res.text));
        this.props.fetchSelectedItem(this.props.params.id)
      } else {
        router.replace(this.slug);
        notify.error({message: err});
      }
    });
  }

  render() {
    return (
      <Modal title={this.title} slug={this.slug}>
        <div>
          <ReactDropzone ref="dropzone" onDrop={this.onDrop} style={{ display: 'none' }}>
            <div>Try dropping a file here, or click to select a file to upload.</div>
          </ReactDropzone>
          <button type="button" className="button small" onClick={this.onOpenClick}>
            Add File
          </button>
        </div>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Inventory/ProductRelatedFileAdd.js